import type { ReactNode } from "react";

import {
  TooltipContent,
  TooltipTrigger,
  Tooltip as TooltipUi,
} from "@roko/ui/components/ui/tooltip";

interface ITooltipProps<T extends ReactNode = ReactNode> {
  content: T;
  children: ReactNode;
}

export const Tooltip = <T extends ReactNode = ReactNode>({
  content,
  children,
}: ITooltipProps<T>) => {
  return (
    <TooltipUi>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent>{content as ReactNode}</TooltipContent>
    </TooltipUi>
  );
};
